<script>
  export let items = [
    {
      size: 6,
      height: '250px',
    },
    {
      size: 6,
      height: '250px',
    },
  ];
  // export let itemHeight = '250px';
</script>

<div class="sb-loader-grid">
  {#each items as loader}
    <div class="sb-loader" style="--loaderSize:{loader.size};--itemHeight:{loader.height}" />
  {/each}
</div>

<style>.sb-loader-grid{box-sizing:border-box;display:grid;gap:1em;grid-template-columns:repeat(12,1fr);height:100%;padding:1em;width:100%}.sb-loader{background-color:#fff;border:1px solid #f2f2f2;border-radius:4px;grid-column:span var(--loaderSize,1);height:var(--itemHeight,250px);overflow:hidden;position:relative;z-index:2}.sb-loader:before{-webkit-animation-duration:1.1s;animation-duration:1.1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:loading;animation-name:loading;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;background-color:#f2f2f2;content:attr(data-fake);display:block;height:100%;overflow:hidden;transform:translate(50%);width:60%}@media (max-width:980px){.sb-loader{grid-column:span 6;height:200px}}@media (max-width:550px){.sb-loader{grid-column:span 12;height:200px}}@-webkit-keyframes loading{0%{transform:translate(-100%)}to{transform:translate(200%)}}@keyframes loading{0%{transform:translate(-100%)}to{transform:translate(200%)}}</style>
